export default __webpack_public_path__ + "bf4bde0cdda543094aafe718ff73af41.png";